import { render } from "./Address.vue?vue&type=template&id=25a9db9a&scoped=true"
import script from "./Address.vue?vue&type=script&lang=ts"
export * from "./Address.vue?vue&type=script&lang=ts"

import "./Address.vue?vue&type=style&index=0&id=25a9db9a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-25a9db9a"

export default script